/**
 * @generated SignedSource<<0f346d221d7abc8a9dcf6afa5f3d044f>>
 * @relayHash 3e6616950cf01d6d63e1363ccc3164f7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e6616950cf01d6d63e1363ccc3164f7

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PolicyExemption = "IGNORE_LOCKDOWN" | "IGNORE_PIN" | "TOLERATE_WINDOWED";
export type UpdateAccommodationInput = {
  accommodationId: string;
  clientMutationId?: string | null;
  newStartTime?: string | null;
  percentTimeExpansion: number;
  policyExemptions?: ReadonlyArray<PolicyExemption> | null;
};
export type accommodationsUpdateMutation$variables = {
  input: UpdateAccommodationInput;
};
export type accommodationsUpdateMutation$data = {
  readonly updateAccommodation: {
    readonly accommodation: {
      readonly id: string;
      readonly newStartTime: string | null;
      readonly percentTimeExpansion: number;
      readonly policyExemptions: ReadonlyArray<PolicyExemption> | null;
    } | null;
  } | null;
};
export type accommodationsUpdateMutation = {
  response: accommodationsUpdateMutation$data;
  variables: accommodationsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAccommodationPayload",
    "kind": "LinkedField",
    "name": "updateAccommodation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Accommodation",
        "kind": "LinkedField",
        "name": "accommodation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "newStartTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentTimeExpansion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "policyExemptions",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accommodationsUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accommodationsUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3e6616950cf01d6d63e1363ccc3164f7",
    "metadata": {},
    "name": "accommodationsUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "24e0b44af14874baf735d938d52b4389";

export default node;
